import React from 'react';
import { Input, DatePicker, Icon, Row, Col, Select, Tag,Radio } from 'antd';
import moment from 'moment';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
class Filters extends React.Component {

     
    handleChange = (option) => {
        this.props.onChange("IdProveedor", option.key, "proveedor", option.label[2].split('-')[0]);
      }
     
      handleChangeEstado = (option) => {
        
            this.props.onChange("IdEstado", option.key, "estado", option.label[2].split('-')[0]);
            //this.props.onChange("cliente", option.label[2])
          }

    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={7}>
                    <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.IdProveedor ?
                                    { key: this.props.filter.IdProveedor } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Proveedor" />}
                            onChange={
                                (option) => 
                                this.handleChange(option) 
                            } //STATE PROPERTY
                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            {this.props.clientes.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id} name={item.tipoDocumento} > <Tag>{item.tipoDocumento}</Tag>{`${item.nombre}-${item.numeroDocumento}`}</Select.Option>
                            ))}
                        </Select> 
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.serie}
                            onChange={(e) => this.props.onChange("serie", e.target.value, null, null)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por serie"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.documento}
                            onChange={(e) => this.props.onChange("documento", e.target.value, null, null)}

                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por documento"
                            autoComplete="off"
                        />
                    </Col>

           
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                    <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.IdEstado ?
                                        { key: this.props.filter.IdEstado } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por Estado" />}
                                onChange={(option) => this.props.onChange("IdEstado", option.key, option, 'estado')}
                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                {this.props.estado.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                                ))}
                            </Select>
                    </Col>
                   


                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <DatePicker
                                placeholder="Filtrar por fecha inicio"
                                format="DD/MM/YYYY"
                                value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                                onChange={(moment, value) => this.props.onChange('fechaInicioStr', value, null, null)}
                            />
                        </Col>
                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <DatePicker
                                placeholder="Filtrar por fecha fin"
                                format="DD/MM/YYYY"
                                value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                                onChange={(moment, value) => this.props.onChange('fechaFinStr', value, null, null)}
                            />
                        </Col>

                    <Col className="gutter-row" sm={24} md={24} lg={6}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                            <Radio.Group
                                value={this.props.filter.tipoReporte}
                                onChange={(e) => this.props.onChange("tipoReporte", e.target.value, null, null)}
                            >
                                <Radio value={0}>General</Radio>
                                <Radio value={1}>Resumen</Radio>
                            </Radio.Group>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

}

export default Filters;